import { Permission } from "@webapp/permissions/models/permissions.model";
import { IPermissionsStoreState } from "./models";

export const hasPermissions = (state: IPermissionsStoreState, ...permissions: Permission[]): boolean =>
  state.permissions.isFetched && permissions.every((permission) => state.permissions.items.has(permission));
